const BadgeSquare = ({ type, children, ...props }) => {
  const body = {
    0: `bg-red-100`,
    3: `bg-red-100`,
    2: ``,
    1: `bg-yellow-100`,
    4: `bg-yellow-100`,
    5: `bg-green-100`,
    6: `bg-green-100`,
    7: `bg-red-100`,
    8: `bg-red-100`,
    9: `bg-gray-100`,
    10: `bg-green-100`,
    11: `bg-red-100`,
    12: `bg-green-100`,
    13: `bg-gray-100`,
    14: `bg-green-100`,
    15: `bg-yellow-100`,
    16: `bg-blue-100`,
    17: `bg-red-100`,
    18: `bg-gray-100`,
    19: `bg-gray-100`,
    20: `bg-yellow-100`,
    21: `bg-orange-100`,
    22: `bg-yellow-100`,
    23: `bg-gray-100`,
    24: `bg-gray-100`,
    25: `bg-red-100`,
  };
  const content = {
    0: `text-red-800`,
    3: `text-red-800`,
    2: ``,
    1: `text-yellow-800`,
    4: `text-yellow-800`,
    5: `text-green-800`,
    6: `text-green-800`,
    7: `text-red-800`,
    8: `text-red-800`,
    9: `text-gray-800`,
    10: `text-green-800`,
    11: `text-red-800`,
    12: `text-green-800`,
    13: `text-gray-800`,
    14: `text-green-800`,
    15: `text-yellow-800`,
    16: `text-blue-800`,
    17: `text-red-800`,
    18: `text-gray-800`,
    19: `text-gray-800`,
    20: `text-yellow-800`,
    21: `text-orange-800`,
    22: `text-yellow-800`,
    23: `text-gray-900`,
    24: `text-gray-900`,
    25: `text-red-800`,
  };
  const text = {
    0: `À importer`,
    3: `Refusé`,
    2: ``,
    1: `Vérification en cours`,
    4: `À vérifier`,
    5: `Validé`,
    6: `Lu`,
    7: `Non Lu`,
    8: `À supprimer`,
    9: `Non signé`,
    10: `Signé`,
    11: `Urgent`,
    12: `Importé`,
    13: `Non importé`,
    14: `Payé`,
    15: `Non payé`,
    16: `Partiellement payé`,
    17: `En retard`,
    18: `Annulé`,
    19: `Brouillon`,
    20: `En attente`,
    21: `À importer sur PennyLane`,
    22: `Suspendue`,
    23: `Annulée`,
    24: `Interrompue`,
    25: `Supprimée`,
  };

  if (
    body[type] === undefined &&
    content[type] === undefined &&
    text[type] === undefined
  )
    return null;

  return (
    <>
      <div className={`flex justify-center items-center rounded ${body[type]} max-w-full overflow-hidden`}>
        <div className={`px-2 py-0.5 ${content[type]} whitespace-nowrap truncate`}>{text[type]}</div>
      </div>
    </>
  );
};

export default BadgeSquare;
